import { httpRequest } from "../../http";

export class CommandDeleteTeamMember {

    async run(employeeId: number, engagementId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/team-members/${employeeId}/`
        try {
            const response = await httpRequest<any>(url, { method: "DELETE" });
            return response
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }
}
